import __vue from 'vue'
import __vue_scrollto from 'vue-scrollto'
import './filters'
window.Vue = __vue;


import axios from "axios";

Vue.prototype.$http = axios;
Vue.use(__vue_scrollto);

new Vue({
    data: {
        awaitingSearch: false,
        search: window.defaultQaSearch ? window.defaultQaSearch : '',
        searchResults: [],
        loading: true,
        errors: [],
        reportForm: {
            loading: false,
            errors: [],
            email_address: '',
            reason: '',
            other: '',
            recaptcha_response: '',
        },
        reportRecaptchaId: null,
        ask: {
            form: {
                title: null,
                category: window.defaultQaCategory ? window.defaultQaCategory : '',
                question: '',
                terms: false
            },
            errors: [],
            loading: false,
        },
        reportUrl: null,
    },
    mounted() {
        if(this.search) {
            this.searchQuestions();
            this.$scrollTo('#searchform', 500, {
                offset: -100,
                force: true
            });
        }
    },
    methods: {
        scrollToAnswer: function (answerId) {
            $('html,body').animate({
                    scrollTop: $(`#answer_${answerId}`).offset().top},
                'slow');
        },
        setReportType: function (type, id) {
            if (type === 'question') {
                this.reportUrl = '/questions/'+id+'/report'
            } else {
                this.reportUrl = '/questions/answer-'+id+'/report'
            }
            window.showMjqPopup('reportquestion');
            this.renderReportRecaptcha();
        },
        renderReportRecaptcha: function () {
            if (this.reportRecaptchaId !== null || !window.grecaptcha) {
                return;
            }

            window.grecaptcha.ready(() => {
                if (this.reportRecaptchaId !== null) {
                    return;
                }

                this.reportRecaptchaId = window.grecaptcha.render(this.$refs.reportRecaptcha, {
                    sitekey: this.$refs.reportRecaptcha.dataset.sitekey,
                    callback: token => {
                        this.reportForm.recaptcha_response = token;
                    },
                    'expired-callback': () => {
                        this.reportForm.recaptcha_response = '';
                    },
                });
            });
        },
        resetReportRecaptcha: function () {
            this.reportForm.recaptcha_response = '';

            if (this.reportRecaptchaId !== null) {
                window.grecaptcha.reset(this.reportRecaptchaId);
            }
        },
        searchQuestions: function () {
            this.loading = true;
            if (!this.search) {
                this.searchResults = [];
            }

            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.searchResult();
                    this.awaitingSearch = false;
                }, 1000);
            }
            this.awaitingSearch = true;
        },
        searchResult: function () {
            axios({
                method: 'post',
                data: {search: this.search},
                url: '/questions/live-search'
            }).then(response => {
                this.searchResults = response.data;
                this.loading = false;
            });
        },
        submitQuestion: function () {
            this.ask.errors = [];
            this.ask.loading = true;

            axios({
                method: 'post',
                data: this.ask.form,
                url: '/questions/ask'
            }).then(response => {
                if (response.data.errors) {
                    this.ask.errors = response.data.errors;
                } else {
                    window.location = response.data.redirect_url;
                }

                this.ask.loading = false;
            });
        },
        submitReport: function () {
            this.reportForm.loading = true;
            this.reportForm.errors = [];

            axios({
                method: 'post',
                data: this.reportForm,
                url: this.reportUrl
            }).then(response => {
                if (response.data.errors) {
                    this.reportForm.errors = response.data.errors;
                } else {
                    window.closePopup();
                    window.showMjqPopup('reported');
                    setTimeout(() => {
                        window.closePopup();
                    }, 3000);
                    this.resetReportForm();
                }
            }).catch(() => {
                this.reportForm.errors = ['Something went wrong. Please try again.'];
            }).finally(() => {
                this.reportForm.loading = false;
                this.resetReportRecaptcha();
            });
        },
        resetReportForm: function () {
            this.reportForm = {
                loading: false,
                errors: [],
                email_address: '',
                reason: '',
                other: '',
                recaptcha_response: '',
            }
        },
        redirectTo: function (url) {
            window.location.href = url
        },
        first: function (obj) {
            return obj[Object.keys(obj)[0]];
        },
    }
}).$mount('#qaapp');